import { getI18n } from "react-i18next";

type Options = {
  prefix?: string | null;
};

export const withNamespace = (namespace: string, options: Options = {}) => {
  const i18n = getI18n();
  const { prefix = null } = options;
  // @ts-expect-error getFixedT overload not typed
  return i18n.getFixedT(null, namespace, prefix);
};
